import { Skeleton } from '@material-ui/lab';
import React from 'react';
import styled from 'styled-components';

interface ProjectListSkeletonProps {}

function ProjectListSkeleton({}: ProjectListSkeletonProps) {
  return (
    <StyledProjectListSkeleton>
      <StyledSkeleton animation="wave" variant="rect" height={326} width={390} />
    </StyledProjectListSkeleton>
  );
}

const StyledProjectListSkeleton = styled.div<{}>``;

const StyledSkeleton = styled(Skeleton)`
  border-radius: 10px;
  background-color: #f4f5fa;
`;

export default ProjectListSkeleton;
